module.exports = __webpack_public_path__ + "static/media/logo.8fd50c4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/svg/logo.svg
// module id = 159
// module chunks = 0